import React, { useEffect, useState } from "react";
import { Card, CardBody, Row, Col, Input, Button, Badge, Spinner, } from "reactstrap";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import useRuleUsers from "../../Hooks/useAutomationRules";

const RuleUsers = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const { ruleUsers, loading, pagination, fetchRuleUsers } = useRuleUsers({
    page,
    search,
  });
  useEffect(() => {
    fetchRuleUsers();
  }, [page, search]);

  return (
    <div className="page-content">
      <Breadcrumbs title="Assignments" breadcrumbItem="Rule Users" />

      <Card>
        <CardBody>
          <Row className="mb-4">
            <Col md={4}>
              <Input
                placeholder="Search User..."
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setPage(1);
                }}
              />
            </Col>
          </Row>

          {loading ? (
            <div className="text-center py-5">
              <Spinner />
            </div>
          ) : !ruleUsers.length ? (
            <div className="text-center py-5">No Users Found</div>
          ) : (
            <div className="table-responsive">
              <table className="table table-bordered align-middle">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>User</th>
                    <th>Email</th>
                    <th>Projects</th>
                    <th>Total Leads</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {ruleUsers.map((user, index) => (
                    <tr key={user._id}>
                      <td>
                        {(page - 1) * (pagination?.limit || 10) + index + 1}
                      </td>

                      <td>
                        <strong>
                          {user.firstName} {user.lastName}
                        </strong>
                      </td>

                      <td>{user.email}</td>

                      <td>
                      {(user.projects || []).length ? (
                        <div className="d-flex flex-wrap gap-1">
                          {user.projects.map((project) => (
                            <Badge key={project.projectId} color="info">
                              {project.projectName} ({project.leadCount})
                            </Badge>
                          ))}
                        </div>
                      ) : (
                        <small className="text-muted">No projects assigned</small>
                      )}
                      </td>

                      <td>
                        <Badge color="success">{user.totalLeads}</Badge>
                      </td>

                      <td>
                        <Button
                          size="sm"
                          color="primary"
                          onClick={() =>
                            navigate(`/user-leads-page/${user._id}`)
                          }
                        >
                          <i className="mdi mdi-eye-outline"></i>
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {!!pagination?.totalPages && (
            <div className="d-flex justify-content-center gap-2 mt-4">
              <Button
                size="sm"
                disabled={page === 1}
                onClick={() => setPage(page - 1)}
              >
                {" "}
                Prev{" "}
              </Button>
              <span className="align-self-center">
                {" "}
                Page {page} / {pagination.totalPages}{" "}
              </span>
              <Button
                size="sm"
                disabled={page === pagination.totalPages}
                onClick={() => setPage(page + 1)}
              >
                Next
              </Button>
            </div>
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default RuleUsers;
